import { useEffect } from 'react';
import Raven from 'raven-js';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';

type Alert = Parameters<typeof FloatingAlertStore.addAlert>[0];

interface UseCaptureErrorProps {
  message: string;
  extra?: Record<string, unknown>;
  alert?: Alert;
}

export function useCaptureError(
  error?: Error,
  { message, extra, alert }: UseCaptureErrorProps = { message: '' }
) {
  useEffect(() => {
    if (error) {
      Raven.captureException(error, {
        extra: {
          message,
          ...extra,
        },
      });

      if (alert) {
        FloatingAlertStore.addAlert({ type: 'danger', ...alert });
      }
    }
  }, [error, message, extra, alert]);
}
